"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useDestroyIfExists = function (widgetInstance) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    react_1.useEffect(function () {
        return function () {
            if (widgetInstance) {
                widgetInstance.destroy();
            }
        };
    }, []);
    react_1.useEffect(function () {
        if (widgetInstance) {
            widgetInstance.destroy();
        }
    }, __spreadArrays(args));
    return widgetInstance;
};
exports.default = useDestroyIfExists;
